'use strict';

var formValidation = require('base/components/formValidation');

module.exports = function () {
    function isValidTextarea(textarea, name) {
        if (textarea.prop('required')) {
            var invalidFeedback = $('div.' + name + '-error');
            invalidFeedback.css('display', 'none');
            invalidFeedback.empty();
            if (textarea.val() === '') {
                invalidFeedback.text(textarea.data('missing-error'));
                invalidFeedback.css('display', 'block');
            } else if (textarea.val().length < textarea.attr('minlength')
                || textarea.val().length > textarea.prop('maxlength')) {
                invalidFeedback.text(textarea.data('range-error'));
                invalidFeedback.css('display', 'block');
            }
        }
    }

    function isValidForm(form) {
        isValidTextarea(form.find('textarea[name$="moreInformation"]'), 'moreInformation');
        isValidTextarea(form.find('textarea[name$="curriculumVitae"]'), 'curriculumVitae');
    }

    $('button#job-application-form-submit').click(function () {
        isValidForm($('form.job-application-form'));
    });

    $('form.job-application-form').submit(function (e) {
        var $form = $(this);
        e.preventDefault();
        var url = $form.prop('action');
        $form.spinner().start();
        $('form.job-application-form').trigger('jobApplicationForm:submit', e);
        $.ajax({
            url      : url,
            type     : 'post',
            dataType : 'json',
            data     : $form.serialize(),
            success  : function (data) {
                $form.spinner().stop();
                if (data.success) {
                    location.href = data.redirectUrl;
                } else {
                    if (data.invalid) {
                        $('#job-application-form-error').removeClass('d-none');
                    }
                    formValidation($form, data);
                }
            },
            error: function () {
                $form.spinner().stop();
            }
        });
        return false;
    });
};
